import { useSelector } from "react-redux"
import { Modal } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { toggleModelBox } from "../../systemSlice"

export const CustomModalBox = ({ title, children }) => {
  const dispatch = useDispatch()

  const { showModal } = useSelector((state) => state.systemState)
  const reload = () => window.location.reload()
  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={() => dispatch(toggleModelBox())}
      backdrop="static"
      onExit={reload}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}
